import { connect, ConnectedProps } from "react-redux";
import { Funnel } from "redmond";
import { IStoreState } from "../../../../reducers/types";

import { TravelOfferSelection } from "./component";
import { withRouter } from "react-router";
import {
  getBestOfferOverall,
  getCredit,
  getCreditToApply,
  getFetchApplicableTravelWalletItemsCallState,
  getIsTravelWalletPaymentOnly,
  getOffers,
  getOfferToApply,
  getRewardsPaymentAccountReferenceId,
  getSelectedPaymentMethodId,
  getMaxApplicableTravelWalletCreditOnlyAmount,
  getPriceQuotePricing,
  getPricingEstimateTotal,
  getIsRequotePending,
  getShowRequoteSuccessBanner,
} from "../../reducer";
import {
  setOfferToApply,
  setSelectedRewardsPaymentTotal,
  resetPaymentCardSelectedAccounts,
  setCreditToApply,
} from "../../actions/actions";
import {
  getCreditBreakdown,
  getTravelCreditsHistoryTransaction,
  getAllTravelWalletOffers,
} from "../../../travel-wallet/reducer";
const mapStateToProps = (state: IStoreState) => {
  const quotePricing = getPriceQuotePricing(state);
  const estimatePricing = getPricingEstimateTotal(state);
  return {
    bestOverallOffer: getBestOfferOverall(state),
    offers: getOffers(state),
    offerToApply: getOfferToApply(state),
    fetchApplicableTravelWalletItemsCallState:
      getFetchApplicableTravelWalletItemsCallState(state),
    selectedPaymentMethodId: getSelectedPaymentMethodId(state) ?? "",
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
    credit: getCredit(state),
    creditBreakdown: getCreditBreakdown(state),
    creditToApply: getCreditToApply(state),
    maxApplicableTravelWalletCreditOnlyAmount:
      getMaxApplicableTravelWalletCreditOnlyAmount(state),
    isTravelWalletPaymentOnly: getIsTravelWalletPaymentOnly(state),
    creditsTransactionHistory: getTravelCreditsHistoryTransaction(state),
    allWalletOffers: getAllTravelWalletOffers(state),
    currentFunnel: Funnel.Lodging,
    isRequotePending: getIsRequotePending(state),
    showRequoteSuccessBanner: getShowRequoteSuccessBanner(state),
    bookingTotal:
      quotePricing?.payNowTotal.fiat.value ?? estimatePricing?.fiat.value ?? 0,
  };
};

export const mapDispatchToProps = {
  setOfferToApply,
  resetPaymentCardSelectedAccounts,
  setSelectedRewardsPaymentTotal,
  setCreditToApply,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TravelOfferSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedTravelOfferSelection = withRouter(
  connector(TravelOfferSelection)
);
